module.exports = __webpack_public_path__ + "img/ball-pink.15332928.png";